import Game from "./Components/Game";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import {useEffect, useRef, useState} from "react";
import axios from "axios";
import {gameStateTypes,} from "./GameStates";
import GameClosed from "./Components/GameClosed";
import GameError from "./Components/GameError";
import CountdownTimer from "./Components/CountdownTimer";
import LockPreview from "./Components/LockPreview";

const dayjs = require("dayjs");

function App() {
  const showLockPreview =
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).has("lockPreview");

  const [gameState, setGameState] = useState({});
  const [error, setError] = useState(false);
  const [lastFetchTime, setLastFetchTime] = useState(0);

  async function getGameState() {
    try {
      const response = await axios.get(
        process.env.NODE_ENV === "production"
          ? "/gameState.json"
          : "http://localhost:3001/gameState.json",
      );

      if (response.status === 200) {
        setError(false);
        setGameState(response.data);
        setLastFetchTime(dayjs());
      } else {
        console.error("Error in response. Statuscode:", response.status);
        setError(true);
      }
    } catch (error) {
      console.error("Something went wrong with the request:", error);
      setError(true);
    }
  }

  // NOTE: DEV ONLY
  // useEffect(() => {
  //   // setGameState(noGame);
  //   // setGameState(noGameWithDate);
  //   // setGameState(gameStartedId1);
  //   setGameState(gameStartedId2);
  //   // setError(true);
  // }, []);

  useEffect(() => {
    getGameState().then();
  }, []);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        const currentTime = dayjs();
        const tenMinutesAgo = currentTime.subtract(10, "minute");

        if (!lastFetchTime || lastFetchTime.isBefore(tenMinutesAgo)) {
          console.debug("refetching");
          getGameState().then();
        } else {
          console.debug(
            "not refetching ::",
            lastFetchTime.toString(),
            "::",
            tenMinutesAgo.toString(),
            "::",
            lastFetchTime.isBefore(tenMinutesAgo),
          );
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [lastFetchTime]);

  const [hasRunningCountdown, setHasRunningCountdown] = useState(true);

  function countdownEnded() {
    setHasRunningCountdown(false);
  }

  useEffect(() => {
    if (gameState.startDate) {
      if (dayjs(gameState.startDate) > dayjs()) {
        setHasRunningCountdown(true);
      } else {
        setHasRunningCountdown(false);
      }
    }
  }, [gameState]);

  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
  const [viewportWidth, setViewportWidth] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setViewportHeight(window.innerHeight);
      setViewportWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [divHeight, setDivHeight] = useState(771);
  const divRef = useRef(null);

  // useEffect(() => {
  //   const getDivHeight = () => {
  //     if (divRef.current) {
  //       setDivHeight(divRef.current.offsetHeight);
  //     }
  //   };
  //   const timeoutId = setTimeout(() => {
  //     getDivHeight();
  //   }, 1000);
  //
  //   return () => {
  //     clearTimeout(timeoutId);
  //   };
  // }, []);

  useEffect(() => {
    const getDivHeight = () => {
      if (divRef.current) {
        setDivHeight(divRef.current.offsetHeight);
      }
    };

    const handleResize = () => {
      getDivHeight();
    };

    window.addEventListener("load", handleResize);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("load", handleResize);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [saveSpace, setSaveSpace] = useState(false);

  useEffect(() => {
    if (
      viewportWidth < 771 &&
      viewportHeight < viewportWidth / 0.648508 &&
      !error &&
      gameState.state === gameStateTypes.game &&
      !hasRunningCountdown
    ) {
      setSaveSpace(true);
    } else {
      setSaveSpace(false);
    }
  }, [
    error,
    viewportHeight,
    divHeight,
    gameState,
    hasRunningCountdown,
    viewportWidth,
  ]);

  if (showLockPreview) {
    return (
      <div className="app">
        <div className="page-container">
          <LockPreview />
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <div className="page-container">
        <div className="game-container">
          <div className="measure-height" ref={divRef}>
            <Header saveSpace={saveSpace} />
            {!error &&
              (gameState.state === gameStateTypes.closed ||
                gameState.state === gameStateTypes.waiting) && (
                <div>
                  <GameClosed gameState={gameState} />
                </div>
              )}
            {!error && gameState.state === gameStateTypes.game && (
              <div>
                {hasRunningCountdown ? (
                  <div className="game-closed">
                    <CountdownTimer
                      endTime={gameState.startDate}
                      countdownEnded={countdownEnded}
                    />
                  </div>
                ) : (
                  <div>
                    <Footer gameState={gameState} saveSpace={saveSpace} />
                    <Game
                      gameState={gameState}
                      viewportHeight={viewportHeight}
                      saveSpace={saveSpace}
                    />
                  </div>
                )}
              </div>
            )}
            {error && (
              <div>
                <GameError />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
